export interface IAdministratorParameters {
    applicationFee: string;
    certificateFee: string;
    supplementFee: string;
    federalAdministrativeLevy: string;
    excludingPaymentAmount: string;
    issuingAuthority: string;
    identifyingLetterOfTheAuthority:string;
    authorizedBy: string;
    nameLineOne:string;
    nameLineTwo:string;
    zipCode:string;
    city:string;
    street:string;
    fullAddress: string;
    email: string;
    telephone: string;
}

export const initIMinistryOfFinance: IAdministratorParameters = {
    applicationFee: "0",
    certificateFee: "0",
    supplementFee: "0",
    federalAdministrativeLevy: "0",
    excludingPaymentAmount: "0",
    issuingAuthority: "via donau - Österr. Wassertr. GmbH",
    identifyingLetterOfTheAuthority:"VD",
    authorizedBy: "BMIMI",
    nameLineOne:"",
    nameLineTwo:"",
    zipCode:"",
    city:"",
    street:"",
    fullAddress:"",
    email:"",
    telephone: "",
};
